/* globals Barba TweenMax Power3 */

// import external dependencies
import 'jquery';
import 'barba.js';
// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/templateHome';
import aboutUs from './routes/about';
import templateGallery from './routes/templateGallery';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  templateHome,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateGallery,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


$('document').ready( () => {
  // Barba.Pjax.start();
  var FadeTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */

      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
      /**
       * this.oldContainer is the HTMLElement of the old Container
       */

      return $(this.oldContainer).animate({ opacity: 0 }).promise();
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;
      var $el = $(this.newContainer);

      $(this.oldContainer).hide();

      $el.css({
        visibility : 'visible',
        opacity : 0,
      });

      $el.animate({ opacity: 1 }, 400, function() {
        /**
         * Do not forget to call .done() as soon your transition is finished!
         * .done() will automatically remove from the DOM the old Container
         */

        _this.done();
      });
    },
  });

  /**
   * Next step, you have to tell Barba to use the new Transition
   */

  Barba.Pjax.getTransition = function() {
    /**
     * Here you can use your own logic!
     * For example you can use different Transition based on the current page or link...
     */

    return FadeTransition;
  };
  Barba.Dispatcher.on('transitionCompleted', () => {
    routes.loadEvents();

  })

  function init() {
    // mobile
    if ($(window).width() <= 720) {
        $('body').addClass('mobile');
    } else {
      $('body').removeClass('mobile');
    }
    $(window).resize(() => {
        if ($(window).width() <= 720) {
            $('body').addClass('mobile');
        } else {
          $('body').removeClass('mobile');
        }
    });


    //animate mobile menu
    $('#nav-toggle').on('click', () => {
        $('#nav-toggle').toggleClass('open');
        if( $('#nav-toggle').hasClass('open') ){
          $('#nav-menu').addClass('is-active');
          TweenMax.staggerFrom(".mobile .menu-item a", 0.5, {marginLeft: '800px', opacity: 0, ease:Power3.easeInOut}, 0.1);
        } else {
          const menuHidden = function menuHidden() {
            $('#nav-menu').removeClass('is-active');
            TweenMax.set(".mobile .menu-item a",{clearProps:"all"});
          }
          TweenMax.staggerTo(".mobile .menu-item a", 0.2, {marginLeft: '800px', opacity: 0, ease:Power3.easeInOut}, -0.1, menuHidden);
          // $(".mobile .menu-item a").css('marginLeft','800px');
        }
    });


    $(".mobile .menu-item a").click( () => {
      $('#nav-toggle').click();
    })
  }

  init();
})



// WEBPACK FOOTER //
// ./scripts/main.js